<template>
  <div id="container">
    <AppHeader />
    <AppBody />
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from './AppHeader'
import AppBody from './AppBody';
import AppFooter from './AppFooter'

export default {
  components: {
    AppHeader,
    AppBody,
    AppFooter
  },
};
</script>

<style>
  #container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #3d3d3d;
  background-color: #FAFAFA;
  margin-top: 60px;
  width: 100%;
  height: 100vh;
}

 body {
margin: 0;
margin-top: -4rem;
}
</style>